module.exports = __webpack_public_path__ + "front/img/btn_2.c047f73e.png";